import { HTMLAttributes } from 'react'
import {
  DisplayProps,
  LayoutProps,
  MarginProps,
  PositionProps,
} from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { IconName } from 'designSystem/components/PDSIcon/PDSIcon'
import INTERNALxNumberTag from 'designSystem/components/internal/INTERNALxNumberTag'

type ValueTagSize = 'sm' | 'md' | 'lg'
type ValueTagVariant = 'arrow' | 'operator'
type Direction = 'down' | 'none' | 'up'

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  MarginProps &
  LayoutProps &
  PositionProps &
  TestIdProps

type Props = {
  decimals?: number
  direction?: Direction
  isNeutral?: boolean
  showDirection?: boolean
  showSymbol?: boolean
  size?: ValueTagSize
  symbol?: string
  value: number
  variant?: ValueTagVariant
} & BaseProps

export default function PDSValueTag({
  decimals,
  direction,
  isNeutral,
  showSymbol = true,
  showDirection = true,
  size = 'md',
  symbol = '%',
  testId,
  value,
  variant = 'operator',
  ...props
}: Props) {
  return (
    <INTERNALxNumberTag
      {...props}
      decimals={decimals}
      direction={direction}
      iconDown={VALUE_TAG_ICON_MAP[variant].iconDown}
      iconUp={VALUE_TAG_ICON_MAP[variant].iconUp}
      isNeutral={isNeutral}
      showDirection={showDirection}
      size={size}
      symbol={showSymbol ? symbol : ''}
      testId={testId}
      value={value}
    />
  )
}

type ValueTagIconMap = {
  [key: string]: {
    iconDown: IconName
    iconUp: IconName
  }
}
const VALUE_TAG_ICON_MAP: ValueTagIconMap = {
  arrow: {
    iconDown: 'arrowDown',
    iconUp: 'arrowUp',
  },
  operator: {
    iconDown: 'minusSmall',
    iconUp: 'plusSmall',
  },
}
